import { Divider } from 'antd';
import { openModal } from './openModal';
import { Icon } from '../../icon/icon';
import { t } from 'i18next';

export const openModalError = config => {
  const modal = openModal({
    content: (
      <>
        <Divider type="horizontal" className="m-0 !p-0" />
        <div className="px-16 py-12 flex items-start justify-start">
          <span className="text-body-medium" style={{ fontSize: '14px' }}>
            {t(
              'The design will be deleted from the system and cannot be undone. Are you sure you want to delete this design?'
            )}
          </span>
        </div>

        <Divider type="horizontal" className="m-0 !p-0" />
      </>
    ),
    centered: true,
    width: 538,
    classNames: {
      header: '!px-16 !py-12 !m-0',
      body: '!p-0',
      footer: '!px-16 !py-12 !gap-16 !items-end !flex !justify-end',
    },
    ...config,
    title: (
      <div className="flex items-center gap-12">
        {config.icon ?? (
          <div className="flex w-32 h-32" style={{ color: '#E5654E' }}>
            <Icon.ICError />
          </div>
        )}

        {config.title}
      </div>
    ),
  });

  return modal;
};
